<template>
  <div style="position: relative;">
    <el-form ref="enterpriseInfoFilter" :model="enterpriseList" :size="defaultFormItemSize"
             label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="企业名称" prop="formFilter.enterpriseName">
          <el-input class="filter-item" v-model="enterpriseList.formFilter.enterpriseName"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="技术领域" prop="formFilter.technologyField">
          <el-input class="filter-item" v-model="enterpriseList.formFilter.technologyField"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetEnterpriseInfo">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshEnterpriseInfo(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('enterpriseInfo:all')"
                   @click="onEnterpriseInfoAddClick()">
          新增
        </el-button>
        <el-button slot="operator" type="success" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('enterpriseInfo:all')"
                   @click="onImportClick()">
          导入
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="enterpriseInfo" :data="enterpriseList.EnterpriseInfo.impl.dataList" :size="defaultFormItemSize" @sort-change="enterpriseList.EnterpriseInfo.impl.onSortChange"
                  header-cell-class-name="table-header-gray"
                  highlight-current-row @current-change="enterpriseList.EnterpriseInfo.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="enterpriseList.EnterpriseInfo.impl.getTableIndex" />
          <el-table-column label="企业名称" prop="enterpriseName" sortable="custom">
          </el-table-column>
          <el-table-column label="技术领域" prop="technologyField" sortable="custom">
          </el-table-column>
          <el-table-column label="联系方式" prop="contactInfo">
          </el-table-column>
          <el-table-column label="备注" prop="remark" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="位置" prop="location">
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime" sortable="custom" width="180px">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="150px">
            <template slot-scope="scope">
              <el-button @click.stop="onEnterpriseInfoEditClick(scope.row)" type="text" :size="defaultFormItemSize"
                         :disabled="!checkPermCodeExist('enterpriseInfo:all')">
                编辑
              </el-button>
              <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                         :disabled="!checkPermCodeExist('enterpriseInfo:all')">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="enterpriseList.EnterpriseInfo.impl.totalCount"
            :current-page="enterpriseList.EnterpriseInfo.impl.currentPage"
            :page-size="enterpriseList.EnterpriseInfo.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="enterpriseList.EnterpriseInfo.impl.onCurrentPageChange"
            @size-change="enterpriseList.EnterpriseInfo.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>

    <el-dialog title="导入企业信息" :visible.sync="enterpriseList.importDialogVisible" width="500px" :close-on-click-modal="false"
               :close-on-press-escape="false"
    >
      <el-upload
        ref="upload"
        :auto-upload="false"
        :on-change="onFileChange"
        :file-list="enterpriseList.fileList"
        accept=".xlsx,.xls"
        drag
        :limit="1"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">仅支持xlsx/xls格式文件，且不超过10MB</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button :size="defaultFormItemSize" @click="enterpriseList.importDialogVisible = false">取消</el-button>
        <el-button type="primary" :size="defaultFormItemSize" :loading="enterpriseList.isImporting" @click="onImportSubmitClick">确定导入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapGetters } from 'vuex';
import { findItemFromList } from '@/utils';
// eslint-disable-next-line no-unused-vars
import rules from '@/utils/validate.js';
import { TableWidget } from '@/utils/widget.js';
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
import { EnterpriseInfoController } from '@/api';

export default {
  name: 'enterpriseList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      enterpriseList: {
        formFilter: {
          enterpriseName: undefined,
          technologyField: undefined
        },
        formFilterCopy: {
          enterpriseName: undefined,
          technologyField: undefined
        },
        EnterpriseInfo: {
          impl: new TableWidget(this.loadEnterpriseInfoWidgetData, this.loadEnterpriseInfoVerify, true, true)
        },
        importDialogVisible: false,
        isImporting: false,
        fileList: [],
        isInit: false
      }
    }
  },
  methods: {
    onResetEnterpriseInfo () {
      this.$refs.enterpriseInfoFilter.resetFields();
      this.refreshEnterpriseInfo(true);
    },
    loadEnterpriseInfoWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        enterpriseInfoDtoFilter: {
          enterpriseName: this.enterpriseList.formFilterCopy.enterpriseName,
          technologyField: this.enterpriseList.formFilterCopy.technologyField
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        EnterpriseInfoController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          if (this.enterpriseList.EnterpriseInfo.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.enterpriseList.EnterpriseInfo.impl.currentRow.id, 'id');
              this.$refs.enterpriseInfo.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadEnterpriseInfoVerify (data) {
      return true;
    },
    refreshEnterpriseInfo (resetPage) {
      this.enterpriseList.formFilterCopy = JSON.parse(JSON.stringify(this.enterpriseList.formFilter));
      if (resetPage) {
        this.enterpriseList.EnterpriseInfo.impl.refreshTable(true, 1);
      } else {
        this.enterpriseList.EnterpriseInfo.impl.refreshTable();
      }
      if (!this.enterpriseList.isInit) {
        // 初始化下拉数据
      }
      this.enterpriseList.isInit = true;
    },
    onEnterpriseInfoAddClick () {
      let params = {
        mode: 'add',
        closeVisible: 1
      };
      this.$router.push({name: 'enterpriseForm', query: params});
    },
    onEnterpriseInfoEditClick (row) {
      let params = {
        id: row.id
      };
      params.closeVisible = 1;
      this.$router.push({name: 'enterpriseForm', query: params});
    },
    onDeleteClick (row) {
      this.$confirm('确定要删除该企业信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        EnterpriseInfoController.delete(this, { id: row.id }).then(res => {
          this.$message.success('删除成功');
          this.refreshEnterpriseInfo(false);
        }).catch(e => {
          this.$message.error('删除失败');
        });
      }).catch(() => {});
    },
    onImportClick () {
      this.enterpriseList.fileList = [];
      this.enterpriseList.importDialogVisible = true;
    },
    onFileChange (file, fileList) {
      this.enterpriseList.fileList = fileList.slice(-1);
    },
    onImportSubmitClick () {
      if (this.enterpriseList.fileList.length === 0) {
        this.$message.warning('请选择要导入的文件');
        return;
      }
      this.enterpriseList.isImporting = true;
      let formData = new FormData();
      formData.append('file', this.enterpriseList.fileList[0].raw);
      EnterpriseInfoController.importData(this, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        if (res.success) {
          let data = res.data;
          this.$message.success(`导入完成：成功${data.successCount}条，失败${data.failCount}条`);
          if (data.failMessages && data.failMessages.length > 0) {
            this.$alert(data.failMessages.join('<br/>'), '导入失败详情', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定'
            });
          }
          this.enterpriseList.importDialogVisible = false;
          this.refreshEnterpriseInfo(true);
        } else {
          this.$message.error(res.message);
        }
      }).catch(e => {
        this.$message.error('导入失败');
      }).finally(() => {
        this.enterpriseList.isImporting = false;
      });
    },
    onResume () {
      this.refreshEnterpriseInfo();
    },
    formInit () {
      this.refreshEnterpriseInfo();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>

<style scoped>
</style>
